export const AZURE_SCOPES = ['openid', 'profile', 'email'];
